import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const ManagementHeader = ({ title, subtitle, backTo, actions }) => {
    const navigate = useNavigate();

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
            <Box display="flex" alignItems="center" gap={2}>
                {backTo && (
                    <IconButton onClick={() => navigate(backTo)}>
                        <ArrowBackIcon sx={{ color: 'primary.main' }} />
                    </IconButton>
                )}

                <Box>
                    <Typography variant="h4" fontWeight={700}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="subtitle2" color="text.secondary">
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </Box>
            {actions && <Box>{actions}</Box>}
        </Box>
    );
};

export default ManagementHeader;
